import { defineComponent, ref, Ref, watch, PropType } from 'vue';
import { HoursOfOperationType } from '@truckdown/locations';
enum HoursTab {
    Hours = 1,
    Exceptions = 2,
    HolidayHours = 3
}

interface IData {
    showAddException: Ref<boolean>,
    tab: Ref<HoursTab>,
}

const getInitialData = function (props: any): IData {
    return {
        tab: ref<HoursTab>(props.hoursType == HoursOfOperationType.SelectHours ? HoursTab.Hours : HoursTab.Exceptions),
        showAddException: ref<boolean>(props.addException),
    };
}

const getMethods = function (data: IData, ctx: any) {
    return {
        updateNavigation: function (tab: HoursTab, buttonState?: boolean) {
            if (buttonState) {
                data.showAddException.value = buttonState;
            } else {
                data.showAddException.value = false;
            }
            data.tab.value = tab;
            ctx.emit("update-navigation", tab, data.showAddException.value);
        }
    };
}

export default defineComponent({
    name: "HoursTableNavigation",
    props: {
        addException: {
            type: Boolean,
            required: false,
            default: false
        },
        hoursType: {
            type: Number as () => HoursOfOperationType,
            required: true
        },
        tableTab: {
            type: Number as PropType<HoursTab>,
            required: false
        },
        timezone: {
            type: String,
            required: false,
            default: ""
        }
    },
    emits: ['update-navigation'],
    
    setup: function (props, ctx) {
        var data = getInitialData(props);
        var methods = getMethods(data, ctx);

        watch(() => props.hoursType, (newVal, oldVal) => {
            if (newVal != undefined && oldVal !== newVal) {
                data.tab.value = props.hoursType == HoursOfOperationType.SelectHours ? HoursTab.Hours : HoursTab.Exceptions;
                ctx.emit("update-navigation", data.tab.value, data.showAddException.value);
            }
        });

        watch(() => props.tableTab, (newVal, oldVal) => {
            if (newVal != undefined && oldVal !== newVal) {
                data.tab.value = newVal
                ctx.emit("update-navigation", data.tab.value, data.showAddException.value);
            }
        });

        return {
            ...data,
            ...methods,
            'HoursTab': HoursTab,
            'HoursOfOperationType': HoursOfOperationType
        }
      
    }
});

